import styles from "./AdvantagesCard.module.scss";
import Heading from "../../Typography/Heading/Heading";
import Text from "../../Typography/Text/Text";

export default function AdvantagesCard({
  number,
  title,
  description,
  backgroundImg,
}) {
  return (
    <div
      className={styles.card}
      style={{ backgroundImage: `url(${backgroundImg})` }}
    >
      <div className={styles.number}>{number}</div>
      <div className={styles.points} />
      <div className={styles.title}>
        <Heading level="h5" fw={600}>
          {title}
        </Heading>
      </div>
      <div className={styles.description}>
        <Text size="base">{description}</Text>
      </div>
    </div>
  );
}
